export default __webpack_public_path__ + "static/media/talakaveri_temple.ee98d80e.jpg";